import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Form } from 'react-bootstrap';
import { enGB } from 'date-fns/locale';
import { lt } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

export const FormikDateTimePickerGroup = ({ field, form, labelText, data }) => {
    const { i18n } = useTranslation();
    const isValid = !form.errors[field.name];
    const isInvalid = form.touched[field.name] && !isValid;

    registerLocale('en', enGB);
    registerLocale('lt', lt);
    setDefaultLocale('en', enGB);

    const getSelectedDate = (value) => {
        return value != null && value !== '' && value !== ' '
            ? new Date(value)
            : null;
    };

    return (
        <Form.Group className={'bdsm-input-group'} controlId={field.name}>
            <Form.Label>{labelText}</Form.Label>
            <div className={'input-group'}>
                <DatePicker
                    selected={getSelectedDate(field.value)}
                    onChange={(date) => field.onChange({ target: { name: field.name, value: date } })}
                    className={isInvalid ? 'form-control is-invalid' : 'form-control'}
                    isInvalid={isInvalid}
                    isValid={form.touched[field.name] && isValid}
                    dateFormat={data.dateFormat}
                    showTimeSelect={data.showTime}
                    timeFormat={data.timeFormat}
                    timeIntervals={data.timeIntervals}
                    locale={i18n.language}
                />
                {isInvalid
                    ? <div className={'date-picker-errors'}>{form.errors[field.name]}</div>
                    : <></>}
            </div>
        </Form.Group>
    );
};